import { WorkflowRepository } from '../domain/workflow.repository'
import { useQuery } from 'react-query'
import { SettingsApi } from '../domain/workflow'
import { Error } from '../../../shared/domain/error'

export const useGetSettings = (repository: WorkflowRepository) => useQuery<SettingsApi, Error>(
  ['workflows-get-settings'],
  async () => await repository.getSettings()
)
